import { type Properties, posthog } from "posthog-js";

let eventQueue: Array<{
  event: string;
  properties?: Properties | null;
}> = [];

export const capturePostHogEvent = (event: string, properties?: Properties | null) => {
  if (!posthog.__loaded) {
    eventQueue.push({
      event,
      properties,
    });
    return;
  }

  if (posthog.consent.isOptedOut()) {
    eventQueue.push({
      event,
      properties,
    });
  } else {
    posthog.capture(event, properties);
  }
};

export const flushEventQueue = () => {
  if (!posthog.__loaded || eventQueue.length === 0) return;

  for (const { event, properties } of eventQueue) {
    posthog.capture(event, properties);
  }

  eventQueue = [];
};
